import Flux from 'lib/flux';

const ModalConstants = Flux.createConstants({
  messages: ['SHOW', 'HIDE'],
});

export default ModalConstants;
